module.exports = __webpack_public_path__ + "img/ico_task_message02.8dcfad0e.svg";